<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import InputPasswordDefault from '@/components/form/InputPasswordDefault.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'InputForm',

  components: {
    InputLeadFormWrapper,
    InputPasswordDefault,
  },

  props: {
    ...formDefaultProps,

    modelValue: {
      type: String,
      required: true,
    },

    header: {
      type: String,
      default: 'パスワード',
    },

    fieldId: {
      type: String,
      default: ''
    },

    placeholder: {
      type: String,
      default: '',
    },

    /**
     * autocomplete 属性に渡す値
     * @see https://developer.mozilla.org/ja/docs/Web/HTML/Attributes/autocomplete
     */
    autocomplete: {
      type: String as PropType<AutocompleteAttr>,
      default: 'off',
    },

    maxlength: {
      type: Number,
      default: undefined,
    },

    hasTrim: {
      type: Boolean,
      default: true,
    },
  },

  emits: ['update:modelValue', 'error', 'trim', 'focus', 'blur'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme"
    @error="$emit('error', $event)">
    <InputPasswordDefault
      :id="fieldId ? fieldId : undefined"
      :model-value="modelValue"
      :name="name"
      :placeholder="placeholder"
      :autocomplete="autocomplete"
      :maxlength="maxlength"
      :has-trim="hasTrim"
      :is-disabled="isDisabled"
      :readonly="readonly"
      :required="required"
      :is-error="hasError"
      @update:model-value="$emit('update:modelValue', $event)"
      @trim="$emit('trim')"
      @focus="$emit('focus')"
      @blur="$emit('blur')" />
  </InputLeadFormWrapper>
</template>
